module.exports = "/_next/static/images/xmr-590b8cd8fe2d20443b7da759d4a07bfc.png";